import { useState } from 'react'
import { Button } from 'components'
import { useSetToast } from 'hooks'
import { validateMessengerProductsToDpsv2 } from 'api/admin'

export const ValidateMessengerProductsToDpsv2Button = () => {
  const [loading, setLoading] = useState(false)
  const setToast = useSetToast()

  const validate = async () => {
    if (loading) return
    setLoading(true)

    try {
      await validateMessengerProductsToDpsv2()

      setToast({
        icon: 'check',
        text: 'Messenger products → dpsv2 validation queued',
      })
    } catch (error) {
      setToast({
        text:
          error instanceof Error && error.message === 'Request timed out'
            ? 'Operation timed out. Please try again later.'
            : 'Failed to queue dpsv2 validation',
      })
    } finally {
      setLoading(false)
    }
  }

  const buttonText = loading
    ? '🛟 Validating Messenger Products → v2...'
    : '🛟 Validate Messenger Products to v2'

  return (
    <Button primary onClick={validate}>
      {buttonText}
    </Button>
  )
}

export default ValidateMessengerProductsToDpsv2Button
